import { HasNameAndDescription } from "userful-chronos-app-common-js/dist/models/common";

export function sortByName<T extends HasNameAndDescription>(items: T[]): T[] {
    return items.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }));
}
